import type React from 'react';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { VitaSeekingReason } from '@xing-com/crate-common-graphql-types';
import { RadioButton } from '@xing-com/radio-button';
import { Headline } from '@xing-com/typography';

import type { OnSaveProps } from '../preferences';

import {
  StyledReasonLabel,
  StyledInputArea,
  StyledButton,
  StyledRadioButtonGroup,
  // StyledBackButton,
} from './reason.styled';

type ReasonProps = {
  onSave: ({ seekingReason, otherSeekingReason }: OnSaveProps) => void;
  onBack: () => void;
};

export const Reason: React.FC<ReasonProps> = ({
  onSave,
  // onBack
}) => {
  const [seekingReason, setSeekingReason] = useState<VitaSeekingReason>();
  const [otherSeekingReason, setOtherSeekingReason] = useState('');
  const intl = useIntl();
  const handleSubmit = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    onSave({ seekingReason, otherSeekingReason });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Headline size="large" sizeConfined="xxlarge">
        <FormattedMessage id="CRATE_VITA_PREFERENCES_REASON_TITLE" />
      </Headline>
      <StyledRadioButtonGroup role="radiogroup" aria-label={'label'}>
        <StyledReasonLabel>
          <RadioButton
            name="reason"
            on={seekingReason === VitaSeekingReason.AlreadyHaveJobToApply}
            onChange={() =>
              setSeekingReason(VitaSeekingReason.AlreadyHaveJobToApply)
            }
            // @ts-expect-error FIXME: SC6
            required
          />
          <FormattedMessage id="CRATE_VITA_PREFERENCES_REASON_ANSWER_1" />
        </StyledReasonLabel>
        <StyledReasonLabel>
          <RadioButton
            name="reason"
            on={seekingReason === VitaSeekingReason.NotForJobToApply}
            onChange={() =>
              setSeekingReason(VitaSeekingReason.NotForJobToApply)
            }
            // @ts-expect-error FIXME: SC6
            required
          />
          <FormattedMessage id="CRATE_VITA_PREFERENCES_REASON_ANSWER_2" />
        </StyledReasonLabel>
        <StyledReasonLabel>
          <RadioButton
            name="reason"
            on={seekingReason === VitaSeekingReason.KeepCvUpToDate}
            onChange={() => setSeekingReason(VitaSeekingReason.KeepCvUpToDate)}
            // @ts-expect-error FIXME: SC6
            required
          />
          <FormattedMessage id="CRATE_VITA_PREFERENCES_REASON_ANSWER_3" />
        </StyledReasonLabel>
        <StyledReasonLabel>
          <RadioButton
            name="reason"
            on={seekingReason === VitaSeekingReason.JustTestCvEditor}
            onChange={() =>
              setSeekingReason(VitaSeekingReason.JustTestCvEditor)
            }
            // @ts-expect-error FIXME: SC6
            required
          />
          <FormattedMessage id="CRATE_VITA_PREFERENCES_REASON_ANSWER_4" />
        </StyledReasonLabel>
        <StyledReasonLabel>
          <RadioButton
            name="reason"
            on={seekingReason === VitaSeekingReason.Other}
            onChange={() => setSeekingReason(VitaSeekingReason.Other)}
            // @ts-expect-error FIXME: SC6
            required
          />
          <FormattedMessage id="CRATE_VITA_PREFERENCES_REASON_ANSWER_5" />
        </StyledReasonLabel>
      </StyledRadioButtonGroup>
      <StyledInputArea
        placeholder={intl.formatMessage({
          id: 'CRATE_VITA_PREFERENCES_REASON_PLACEHOLDER',
        })}
        multiline
        minLength={5}
        maxLength={255}
        name="other-reason"
        required={seekingReason === VitaSeekingReason.Other}
        value={otherSeekingReason}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
          setOtherSeekingReason(event?.target.value)
        }
      />
      {/* <StyledBackButton onClick={onBack} variant="secondary" type="text">
        <FormattedMessage id="CRATE_VITA_PREFERENCES_BACK" />
      </StyledBackButton> */}
      <StyledButton variant="primary" type="submit" disabled={!seekingReason}>
        <FormattedMessage id="CRATE_VITA_PREFERENCES_DONE" />
      </StyledButton>
    </form>
  );
};
